import React, {createRef, ReactNode, RefObject} from "react";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Menu} from "primereact/menu";
import {DropdownChangeEvent, DropdownProps} from "primereact/dropdown";
import {MenuItem} from "primereact/menuitem";
import FunctionHelper from "../helper/FunctionHelper";
import PortalPureComponent from "./PortalPureComponent";

interface PageRangeProperties extends DropdownProps {
	addon?: string
}

export default class PageRange extends PortalPureComponent<PageRangeProperties, any> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let menu: RefObject<Menu> = createRef<Menu>();
		let menuItems: Array<MenuItem> = [];

		for (let item of FunctionHelper.applyValue(this.props.options, [])) {
			menuItems.push({
				label: item.label,
				command: (e) => {
					if (!FunctionHelper.exists(this.props.onChange)) {
						return;
					}

					this.props.onChange!({
						value: item.value,
						originalEvent: e.originalEvent
					} as DropdownChangeEvent);
				}
			})
		}

		return (
			<div className={"p-inputgroup page-range " + this.props.className}>
				<InputText tooltip={this.props.tooltip} value={this.props.value} id={this.props.inputId}
						   onInput={(e) => {
							   if (!FunctionHelper.exists(this.props.onChange)) {
								   return;
							   }

							   this.props.onChange!({
								   value: e.currentTarget.value
							   } as DropdownChangeEvent);
						   }}/>
				<span className="p-inputgroup-addon">{this.props.addon}</span>
				<Button icon="icon icon-angle-down" aria-controls={this.props.inputId + "-menu"}
						onClick={(event) => menu.current!.toggle(event)}
						aria-haspopup={true}/>
				<Menu popup={true} ref={menu} id="page-range-menu" appendTo={this.props.appendTo} model={menuItems}/>
			</div>
		);
	}
}